import { createSlice } from "@reduxjs/toolkit";
export interface IUiState {
    isShowSidebar: boolean
    isShowCart: boolean
    isShowProductDetail: boolean
    isShowComboDetail: boolean
    isShowPageNotFound: boolean
}
const initialState: IUiState = {
    isShowSidebar: false,
    isShowCart: false,
    isShowProductDetail: false,
    isShowComboDetail: false,
    isShowPageNotFound: false,
}
export const uiSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        showSidebarModal(state) {
            state.isShowSidebar = !state.isShowSidebar;
        },
        showCartModal(state) {
            state.isShowCart = !state.isShowCart;
        },
        showProductDetailModal(state) {
            state.isShowProductDetail = !state.isShowProductDetail;
        },
        showComboDetailModal(state) {
            state.isShowComboDetail = !state.isShowComboDetail;
        },
        showPageNotFound(state) {
            state.isShowPageNotFound = !state.isShowPageNotFound;
        },
        disableScrollScreen() {
            document.body.classList.add('overflow-hidden');
        },
        enableScrollScreen() {
            document.body.classList.remove('overflow-hidden');
        },
    }
})
export const {
    showSidebarModal,
    showCartModal,
    showProductDetailModal,
    showComboDetailModal,
    enableScrollScreen,
    disableScrollScreen,
    showPageNotFound,
} = uiSlice.actions;
export default uiSlice.reducer;